module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiBAMAAADIaRbxAAAAMFBMVEUAAAA0NDQ1NTU5OTk0NDQ0NDQ2NjY0NDQ0NDQ0NDQ0NDQ1NTU1NTU3NzdAQEAzMzN79c8NAAAAD3RSTlMA7TANZsYl8svFcGFEHBDH6ZVZAAAAfklEQVQoz2MYeHAZQrHBBXg/KoAo5vkbYCLM8kIgyvT/AbgiRZAi5vgvCHOY5IVAShxAbIQimBKEIpgShKJ+qBKEIjQlDMz93xUQPIhb6oWQuGC3AK1DVeIAtA5VCcThUAB1Loqi+V8gbkqACbCBlIAULYCr2QOhsh4wDAkAALcyJKIGfO4pAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/close.png
// module id = tv85
// module chunks = 32